define('home/views/CommentCardPostActionsView',[
    'jquery',

    'home/views/PostActionsView',
    'home/templates/commentCardPostActions',
], function (
    $,

    PostActionsView,
    commentCardPostActionsTemplate
) {
    'use strict';

    var CommentCardPostActionsView = PostActionsView.extend({
        template: commentCardPostActionsTemplate,

        // TODO support inline replies
        initializeReplyViewManager: $.noop,
        toggleReplyView: $.noop,
    });

    return CommentCardPostActionsView;
});

